import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import Search from '@mui/icons-material/Search';
import AppBindStyles from '../../AppBindStyles';

class SearchFieldNarrow extends Component {

  render() {
    return (
      <React.Fragment>
        <TextField
          style={AppBindStyles.searchField160}
          id={this.props.id}
          label={this.props.label}
          value={this.props.value}
          onChange={(e) => {this.props.onChange(e)}}
        />
        <Search color="disabled" style={{marginLeft: -28, marginBottom: -26, marginRight:0}}/>
      </React.Fragment>
    );
  }
}
 
SearchFieldNarrow.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
  
export default SearchFieldNarrow;
